<template>
  <div class="my-pooq-content-body">
    <portal to="delete-edit-header" v-if="voucherPackageList.length > 0">
      <my-pooq-history-header :change-mode="changeMode" :checked-count="checkedCount" :delete-all="deleteAll"
                              :delete-selected="deleteSelected" :is-delete-mode="isDeleteMode" :total-count="totalCount"/>
    </portal>
    <div class="mypooq-list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200">
      <my-pooq-empty-list v-if="showEmptyList"
                          info-text="패키지 구매 내역이 없어요."></my-pooq-empty-list>
      <div>
      </div>
      <ul class="content-list package-list">
        <li v-for="(voucherPackage, index) in voucherPackageList" :key="'voucherPackage' + index">
            <span class="list-select" v-if="isDeleteMode" @click.prevent="()=>togglePackageCheck(voucherPackage)">
            <input type="checkbox" :id="'select-btn_' + index" class="select-btn" v-model="voucherPackage.check">
            <label :for="'select-btn_' + index">
                <span class="a11y-hidden">내역 체크박스</span>
                <CheckOn v-if="voucherPackage.check"/>
                <CheckOff v-if="!voucherPackage.check"/>
            </label>
            </span>
            <span class="package-box" @click.prevent="clickToggle(voucherPackage)">
                <span class="content-box">
                  <span class="content-info">
                      <span class="product-name">{{voucherPackage.title}}</span>
                      <span class="product-meta">
                        <span>구매일시</span>
                        <i class="icon-dotted"></i>
                        <span>{{voucherPackage.startdatetime}}</span>
                      </span>
                      <span class="product-meta">
                        <span>구매금액</span>
                        <i class="icon-dotted"></i>
                        <span>{{voucherPackage.price | amount}}원</span>
                      </span>
                      <span class="product-meta">
                        <span>만료</span>
                        <i class="icon-dotted"></i>
                        <span>{{voucherPackage.enddatetime}}</span>
                      </span>
                      <span class="product-meta">
                        <span>결제방법</span>
                        <i class="icon-dotted"></i>
                        <span>{{voucherPackage.paidtypetext}}</span>
                      </span>
                  </span>
                  <span class="package-toggle">
                    <ListOpenIcon v-if="!voucherPackage.toggle"/>
                    <ListCloseIcon v-if="voucherPackage.toggle"/>
                  </span>
                </span>
                <voucher-package v-if="voucherPackage.toggle" :package-list-info="voucherPackage" :own="voucherPackage.own"></voucher-package>
            </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { MyPooqService } from '@/common/api/api.service'
import { resizeThumbnail } from '@/common/image.filter'
import { get, throttle } from 'lodash'
import { infiniteScroll } from '@/common/directives'
import VoucherPackage from '@/components/lnb/mypooq/VoucherPackage'
import MyPooqHistoryHeader from '@/components/lnb/mypooq/MyPooqHistoryHeader'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import { amount } from '@/common/filters'
import CheckOn from '@/assets/svg/common/ic-check-on.svg'
import CheckOff from '@/assets/svg/common/ic-check-off.svg'
import { MAX_SELECT_COUNT } from '@/common/constant'
import ListOpenIcon from '@/assets/svg/common/ic-list-open-l.svg'
import ListCloseIcon from '@/assets/svg/common/ic-list-close-l.svg'
import utils from '@/common/util/utils'

export default {
  name: 'MyPooqVoucherListPackage',
  directives: {
    infiniteScroll
  },
  filters: {
    amount
  },
  components: {
    MyPooqHistoryHeader,
    VoucherPackage,
    MyPooqEmptyList,
    CheckOn,
    CheckOff,
    ListOpenIcon,
    ListCloseIcon
  },
  data () {
    return {
      offset: 0,
      limit: 10,
      totalCount: 0,
      isDeleteMode: false,
      endOfList: false,
      showEmptyList: false,
      voucherPackageList: [],
      toggle: 'y'
    }
  },
  computed: {
    checkedCount () {
      return this.voucherPackageList.filter(packageItem => packageItem.check).length
    }
  },
  methods: {
    togglePackageCheck (packageItem) {
      if (this.checkedCount >= MAX_SELECT_COUNT) {
        utils.alert(`최대 ${MAX_SELECT_COUNT}개 까지만 선택할 수 있습니다.`)
      } else {
        packageItem.check = !packageItem.check
      }
    },
    deleteSelected () {
      const checkedList = this.voucherPackageList.filter((item) => {
        return item.check
      }).map((item) => {
        return item.paymentid
      })
      if (checkedList.length > 0) {
        MyPooqService.deleteMyPurchaseContentItem({ paymentId: checkedList }).then(({ data }) => {
          this.voucherPackageList = []
          this.offset = 0
          this.totalCount = 0
          this.$nextTick(() => {
            this.setData()
          })
        })
      }
    },
    deleteAll () {
      MyPooqService.deleteMyPurchasePackageAll().then(({ data }) => {
        this.voucherPackageList = []
        this.offset = 0
        this.totalCount = 0
        this.$nextTick(() => {
          this.setData()
        })
      })
    },
    changeMode () {
      if (this.isDeleteMode) { // off 시킬때
        this.voucherPackageList = this.voucherPackageList.map((voucherPackage) => {
          voucherPackage.check = false
          return voucherPackage
        })
      }
      this.isDeleteMode = !this.isDeleteMode
    },
    loadMore: throttle(function () {
      if (this.endOfList) return
      this.setData()
    }, 120),
    setData () {
      MyPooqService.myPurchaseContentPackage({
        offset: this.offset,
        limit: this.limit
      }).then(({ data }) => {
        const resList = get(data, 'list', []).map((item) => {
          item.check = false
          item.toggle = false
          // item.tags = []
          // item.tags.push(item.own === 'y' ? 'own' : 'rent')
          return item
        })
        if (this.totalCount === 0) {
          this.totalCount = Number(get(data, 'pagecount', 0))
        }
        this.endOfList = resList.length === 0
        this.showEmptyList = this.voucherPackageList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.voucherPackageList = this.voucherPackageList.concat(resList)
      })
    },
    getLazyLoadObj (voucherSingle) {
      return {
        src: resizeThumbnail(voucherSingle.image, { width: 340, height: 480, quality: 75, multiply: 3 }),
        error: '/img/common/img_default_thum_1.png',
        loading: '/img/common/img_default_thum_1.png'
      }
    },
    clickToggle (voucherPackage) {
      voucherPackage.toggle = !voucherPackage.toggle
    }
  }
}
</script>

<style scoped>
  .my-pooq-content-body {
    position: relative;
    width: 100%;
    /*overflow-y:scroll;*/
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
  }
  .my-pooq-content-body::-webkit-scrollbar{
    display: none
  }
  .mypooq-list {
    position: relative;
    width: 100%;
    height: auto;
    /*overflow-y: scroll;*/
  }
  .select-btn {
    display: none !important;
  }
</style>
